import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import library1 from '../../../assets/front/img/library/libslide-1.png';
import library2 from '../../../assets/front/img/library/libslide-2.png';
import library3 from '../../../assets/front/img/library/libslide-3.png';
import lib1 from '../../../assets/front/img/library/lib-1.jpg';
import lib2 from '../../../assets/front/img/library/lib-2.jpg';

class Intro extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        var settings = {
            autoplay: true,
            dots: true,
            infinite: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className="container">
                <div className="g-mt-30 g-mb-50">
                    <Slider {...settings}>
                        <div>
                            <img src={library1} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                        <div>
                            <img src={library2} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                        <div>
                            <img src={library3} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                    </Slider>
                </div>

                <div className="row justify-content-center">
                    <div className="col col-lg-9">
                        <h2 className="h4 g-color-black g-font-weight-600 mb-3">동물, 어디까지 알고 계세요?</h2>
                        <div className="mb-4">
                            <p className="g-line-height-1_8">골목 구석구석에서 마주하는 고양이와 강아지들, 머리 위를 날아다니는 새들, 숲 속에서 마주하는 토끼, 너구리, 야생동물들, 무심코 스쳐 지나가지만 항상 우리와 함께인 동물들에 대해 우리는 아직도 배울 것이 많습니다.</p>
                            <p className="g-line-height-1_8">카라의 동물전문도서관 ‘생명공감 킁킁도서관’은 우리와 함께 공존하며 살아가는 소중한 생명, 동물에 대한 이해를 돕기 위해 만들어졌습니다. 동물에 관한 모든 것을 만날 수 있는 국내 최초의 동물전문도서관, 킁킁도서관은 아는 만큼 보이는 동물 이야기가 가득한 곳으로, 생명존중문화의 허브역할을 할 것을 약속합니다.</p>
                        </div>

                        <hr />

                        <div className="g-mb-30">
                            <h3 className="h4 g-color-black g-font-weight-600 mb-3">킁킁도서관에서는?</h3>
                            <p className="g-line-height-1_8">생명공감 킁킁도서관은 동물 이야기를 담은 동화책에서부터 동물권에 대한 해외 전문서까지 다양한 동물관련 책을 누구나 와서 볼 수 있는 국내 최초의 동물전문도서관입니다.</p>
                            <ul className="list-unstyled">
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>동물관련 전문서적 및 아동서적 국내외 약 6,000건 확보</li>
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>동물, 환경 관련 서적의 독서를 통해 생명존중의식 확산</li>
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>킁킁 전자도서관으로 지역과 공간의 경계를 넘어 동물도서 접근성 확대</li>
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>국내최초 동물전문아카이브 구축 및 상시적인 교육의 장 역할</li>
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>동물권행동 카라의 출판서적, 교육자료, 교육도구 등을 열람 및 구입 가능</li>
                                <li><i className="g-color-blue-gradient-opacity-v1 mr-2 mb-2 fa fa-star"></i>동물권행동 카라의 지난 10년 간의 활동을 열람 및 검색 가능</li>
                            </ul>
                        </div>

                        <a href="https://www.ekara.org/book" target="_blank" className="btn u-btn-primary rounded-0 g-ml-20 g-mb-15">킁킁도서관 자료검색 <i className="material-icons g-font-size-16">launch</i></a>
                        <a href="https://kara.dkyobobook.co.kr" target="_blank" className="btn u-btn-primary rounded-0 g-ml-20 g-mb-15">킁킁 전자도서관 <i className="material-icons g-font-size-16">launch</i></a>
                        <a href="https://www.instagram.com/kara_library" target="_blank" className="btn u-btn-primary rounded-0 g-ml-20 g-mb-15">킁킁도서관 인스타그램 <i className="material-icons g-font-size-16">launch</i></a>

                        <hr />

                        <h3 className="h4 g-color-black g-font-weight-600 mb-3">사서냥이 무쇠와 알식</h3>
                        <div className="row g-pb-15">
                            <div className="col-md-4">
                                <img src={lib1} className="img-fluid" alt="" />
                            </div>
                            <div className="col-md-4">
                                <img src={lib2} className="img-fluid" alt="" />
                            </div>
                            <div className="col-md-4">
                                <p className="g-line-height-1_8">킁킁도서관에는 두 마리의 고양이가 함께 지내고 있습니다. 알식이와 무쇠는 어린 시절에 구조되었으나 몸이 약해서 치료 후에도 방사나 입양을 보내지 않고 카라 더불어숨센터에서 활동가들과 지내고 있던 고양이들로 2016년부터 킁킁도서관에서 지내게 되었습니다.</p>
                            </div>
                        </div>
                        <p className="g-line-height-1_8 mb-0">고양이와 인간이 서로 잘 지내기 위해서 도서관 곳곳에 안내문을 붙여놓았습니다. 도서관 방문자 분들은 안내문을 꼭 확인해 주시길 바랍니다.</p>

                        <hr />

                        <div className="g-mb-50">
                            <h3 className="h4 g-color-black g-font-weight-600 mb-3">킁킁도서관 이용안내</h3>
                            <ul>
                                <li className="mb-3"><b>운영요일</b> &nbsp; 화~금요일</li>
                                <li className="mb-3"><b>운영시간</b> &nbsp; 오후 2시 ~ 오후 7시</li>
                                <li className="mb-3"><b>휴관일</b> &nbsp; 매주 월요일 및 주말</li>
                            </ul>
                            <div className="g-bg-gray-light-v5 u-ns-bg-v2-top g-bg-gray-light-v5 g-pa-20">
                                <p className="mb-0">킁킁도서관은 생명보험사회공헌위원회와 교보생명의 지원을 받아 만들어졌습니다</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/pages/front/library/intro.js